// src/hooks/useInsuranceReports.ts

import { useCallback } from "react";

import type {
  Report,
} from "../contexts/InsuranceContextType";

interface UseInsuranceReportsOptions {
  setReports: React.Dispatch<
    React.SetStateAction<Report[]>
  >;
}

interface UseInsuranceReportsReturn {
  addReport: (
    reportData: Omit<
      Report,
      "id" | "createdAt" | "updatedAt"
    >
  ) => Promise<void>;
}

const createReportId = (): string =>
  `RPT-${Date.now()}`;

export function useInsuranceReports({
  setReports,
}: UseInsuranceReportsOptions): UseInsuranceReportsReturn {
  const addReport = useCallback(
    async (
      reportData: Omit<
        Report,
        "id" | "createdAt" | "updatedAt"
      >
    ) => {
          throw new Error(
            "This action is currently unavailable. Your changes have not been saved."
          );
        },
    [setReports]
  );

  return {
    addReport,
  };
}

export default useInsuranceReports;